module.exports = __webpack_public_path__ + "media/mode_circulaire/arrow-1_2-50406203.png";